"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAdvancedTextFilter = exports.useEventListener = exports.createFilters = exports.createAliases = exports.removeAccent = void 0;
const common_types_1 = require("../../../common-types");
const react_1 = require("react");
const lodash_1 = require("lodash");
/**
 * Replace all non-english characters with its normalized form.
 *
 * @param value
 */
function removeAccent(value) {
    return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
exports.removeAccent = removeAccent;
/**
 * Derive alias array from table columns.
 *
 * @param columns
 */
function createAliases(columns) {
    return columns
        .filter((column) => column.filterable)
        .map((column) => {
        var _a;
        return ({
            key: (column.filterkey || column.datakey).replace('.id', '.name'),
            label: column.name,
            nonAccentLabel: removeAccent(column.name),
            source: (_a = column.FilterComponent) === null || _a === void 0 ? void 0 : _a.source,
        });
    });
}
exports.createAliases = createAliases;
/**
 * Replace all filter labels in input with key found in alias array.
 *
 * @param filters
 * @param aliases
 */
function createFilters(filters, aliases) {
    const copy = (0, lodash_1.cloneDeep)(filters);
    copy.forEach((filter) => {
        var _a;
        if (filter.filters) {
            filter.filters = createFilters(filter.filters, aliases);
        }
        else {
            filter.field = aliases.find((a) => {
                var _a, _b;
                return a.nonAccentLabel === ((_a = filter.field) === null || _a === void 0 ? void 0 : _a.trim()) ||
                    a.label === ((_b = filter.field) === null || _b === void 0 ? void 0 : _b.trim());
            }).key;
            filter.value = (_a = filter.value) === null || _a === void 0 ? void 0 : _a.trim();
        }
    });
    return copy;
}
exports.createFilters = createFilters;
/**
 * Event listener helper hook.
 *
 * @param type
 * @param handler
 */
function useEventListener({ target, types, handler, shouldRegister = true, }) {
    const handleRef = (0, react_1.useRef)(handler);
    (0, react_1.useEffect)(() => {
        handleRef.current = handler;
    });
    (0, react_1.useEffect)(() => {
        function internalHandler(ev) {
            return handleRef.current(ev);
        }
        if (shouldRegister) {
            types.forEach((type) => {
                target === null || target === void 0 ? void 0 : target.addEventListener(type, internalHandler);
            });
        }
        return () => {
            types.forEach((type) => {
                target === null || target === void 0 ? void 0 : target.removeEventListener(type, internalHandler);
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [target, shouldRegister]);
}
exports.useEventListener = useEventListener;
function getAdvancedTextFilter(text, fields = []) {
    if (!text) {
        return null;
    }
    const filters = {
        operation: common_types_1.ApiFilterOperation.OR,
        filters: [],
    };
    filters.filters = fields.map((field) => {
        const newFilter = text
            .replaceAll('"field":"text"', `\"field\":\"${field}\"`)
            .replaceAll('"fields":{"text":1}', `\"field\":{\"${field}\":1}`);
        return JSON.parse(newFilter);
    });
    return filters;
}
exports.getAdvancedTextFilter = getAdvancedTextFilter;
//# sourceMappingURL=utils.js.map